import type { ForwardedRef } from 'react';
import { forwardRef, memo, useContext } from 'react';
import { AppContext } from '../context';
import { isOldHeader } from '../../main/util/getHeaderVersion';
import useTrackHeaderImpression from '../../main/hooks/googleAnalytics/useTrackHeaderImpression';
import GoogleAnalyticsProvider from '../../main/contexts/GoogleAnalyticsProvider';
import ComponentSuspense from './router/ComponentSuspense';
import styles from './Layout.module.scss';
import Header from './Header';
import LazyComponent from './router/LazyComponent';

const ImpersonationActiveBanner = LazyComponent(
    async () => import('./layout/ImpersonationActiveBanner')
);

const NewHeader = LazyComponent(
    async () => import('../../layout/components/Header/Header')
);

const ImpersonationActiveBannerV1 = LazyComponent(
    async () => import('../../layout/components/ImpersonationActiveBanner')
);

const AppHeader = (props: unknown, ref: ForwardedRef<HTMLDivElement>) => {
    const { isImpersonating } = useContext(AppContext);
    const isNewHeader = !isOldHeader();
    useTrackHeaderImpression();

    return (
        <GoogleAnalyticsProvider>
            {isNewHeader ? (
                <>
                    {isImpersonating && (
                        <ComponentSuspense height="40px">
                            <ImpersonationActiveBannerV1 />
                        </ComponentSuspense>
                    )}
                    <ComponentSuspense
                        height="82px"
                        className={styles.headerLoading}
                    >
                        <NewHeader ref={ref} />
                    </ComponentSuspense>
                </>
            ) : (
                <>
                    {isImpersonating && (
                        <ComponentSuspense height="40px">
                            <ImpersonationActiveBanner />
                        </ComponentSuspense>
                    )}
                    <Header ref={ref} />
                </>
            )}
        </GoogleAnalyticsProvider>
    );
};

export default memo(forwardRef(AppHeader));
